import useRepo from '@/nebula/repo';
import { AND, EQ, RESULT, UID } from 'shared/api/query/constants';
import { customDatasourceProperty } from 'shared/constants.json';
import {
  dataSource as dataSourceConfig,
} from 'shared/api/query/configs.json';
import { ref } from 'vue';

export default function useAzureDevOpsDatasourceRepo() {
  const repo = useRepo(dataSourceConfig.model);

  const getProjectsLoading = ref(false);
  const getProjects = (entity) => {
    getProjectsLoading.value = true;
    return repo.query([{
      alias: RESULT,
      func: { name: UID },
      model: dataSourceConfig.model,
      uid: [entity.uid],
      children: [
        { attr: UID },
        { attr: customDatasourceProperty.dataSourceError, default: null },
        {
          attr: customDatasourceProperty.azureDevOpsProjects,
          default: [],
          filter: { func: { name: EQ, attr: customDatasourceProperty.azureDevOpsOrganizations, args: [{ value: entity[customDatasourceProperty.azureDevOpsOrganizations][0].name }] } },
        },
      ],
    }]).then(() => repo.selectSingle(entity.uid)).finally(() => {
      getProjectsLoading.value = false;
    });
  };

  const getProject = (entity) => {
    getProjectsLoading.value = true;
    return repo.query([{
      alias: RESULT,
      func: { name: UID },
      model: dataSourceConfig.model,
      uid: [entity.uid],
      children: [
        { attr: UID },
        { attr: customDatasourceProperty.dataSourceError, default: null },
        {
          attr: customDatasourceProperty.azureDevOpsProjects,
          default: [],
          filter: {
            op: AND,
            child: [
              { func: { name: EQ, attr: customDatasourceProperty.azureDevOpsOrganizations, args: [{ value: entity[customDatasourceProperty.azureDevOpsOrganizations][0].name }] } },
              { func: { name: EQ, attr: customDatasourceProperty.azureDevOpsProjects, args: [{ value: entity[customDatasourceProperty.azureDevOpsProjects][0].id }] } },
            ],
          },
        },
      ],
    }]).then(() => repo.selectSingle(entity.uid)).finally(() => {
      getProjectsLoading.value = false;
    });
  };

  const getSharedQueriesLoading = ref(false);
  const getSharedQueries = (entity) => {
    getSharedQueriesLoading.value = true;
    return repo.query([{
      alias: RESULT,
      func: { name: UID },
      model: dataSourceConfig.model,
      uid: [entity.uid],
      children: [
        { attr: UID },
        { attr: customDatasourceProperty.dataSourceError, default: null },
        {
          attr: customDatasourceProperty.azureDevOpsSharedQueries,
          default: [],
          filter: {
            op: AND,
            child: [
              { func: { name: EQ, attr: customDatasourceProperty.azureDevOpsOrganizations, args: [{ value: entity[customDatasourceProperty.azureDevOpsOrganizations][0].name }] } },
              { func: { name: EQ, attr: customDatasourceProperty.azureDevOpsProjects, args: [{ value: entity[customDatasourceProperty.azureDevOpsProjects][0].id }] } },
            ],
          },
        },
      ],
    }]).then(() => repo.selectSingle(entity.uid)).finally(() => {
      getSharedQueriesLoading.value = false;
    });
  };

  const getWorkItemsLoading = ref(false);
  const getWorkItemsBySharedQuery = (entity) => {
    getWorkItemsLoading.value = true;
    return repo.query([{
      alias: RESULT,
      func: { name: UID },
      model: dataSourceConfig.model,
      uid: [entity.uid],
      children: [
        { attr: UID },
        { attr: customDatasourceProperty.dataSourceError, default: null },
        {
          attr: customDatasourceProperty.azureDevOpsWorkItems,
          default: [],
          filter: {
            op: AND,
            child: [
              { func: { name: EQ, attr: customDatasourceProperty.azureDevOpsOrganizations, args: [{ value: entity[customDatasourceProperty.azureDevOpsOrganizations][0].name }] } },
              { func: { name: EQ, attr: customDatasourceProperty.azureDevOpsProjects, args: [{ value: entity[customDatasourceProperty.azureDevOpsProjects][0].id }] } },
              { func: { name: EQ, attr: customDatasourceProperty.azureDevOpsSharedQueries, args: [{ value: entity[customDatasourceProperty.azureDevOpsSharedQueries][0].id }] } },
            ],
          },
        },
      ],
    }]).then(() => repo.selectSingle(entity.uid)).finally(() => {
      getWorkItemsLoading.value = false;
    });
  };

  const getWorkItemsByType = (entity) => {
    getWorkItemsLoading.value = true;
    return repo.query([{
      alias: RESULT,
      func: { name: UID },
      model: dataSourceConfig.model,
      uid: [entity.uid],
      children: [
        { attr: UID },
        { attr: customDatasourceProperty.dataSourceError, default: null },
        {
          attr: customDatasourceProperty.azureDevOpsWorkItems,
          default: [],
          filter: {
            op: AND,
            child: [
              { func: { name: EQ, attr: customDatasourceProperty.azureDevOpsOrganizations, args: [{ value: entity[customDatasourceProperty.azureDevOpsOrganizations][0].name }] } },
              { func: { name: EQ, attr: customDatasourceProperty.azureDevOpsProjects, args: [{ value: entity[customDatasourceProperty.azureDevOpsProjects][0].id }] } },
              { func: { name: EQ, attr: customDatasourceProperty.azureDevOpsWorkItemType, args: [{ value: entity[customDatasourceProperty.azureDevOpsWorkItemType][0].name }] } },
            ],
          },
        },
      ],
    }]).then(() => repo.selectSingle(entity.uid)).finally(() => {
      getWorkItemsLoading.value = false;
    });
  };

  return {
    getProjectsLoading,
    getProjects,
    getProject,
    getSharedQueriesLoading,
    getSharedQueries,
    getWorkItemsLoading,
    getWorkItemsBySharedQuery,
    getWorkItemsByType,
  };
}
